import React from 'react';

import './style.scss';

export interface ICitizenMapMobileTopBarProps {
  activeView: 'map' | 'list';
  requestCountText: string;
  onFilterClick?: () => void;
  onViewChange: (view: 'map' | 'list') => void;
}

export default function CitizenMapMobileTopBar({
  activeView,
  requestCountText,
  onFilterClick,
  onViewChange,
}: ICitizenMapMobileTopBarProps) {
  return (
    <div className="citizen-map-mobile-top-bar">
      <div className="citizen-map-mobile-top-bar__request-count">{requestCountText}</div>
      <div className="citizen-map-mobile-top-bar__view-toggle" role="group" aria-label="Select map or list view">
        <button
          type="button"
          className={`citizen-map-mobile-top-bar__view-toggle-button${
            activeView === 'map' ? ' citizen-map-mobile-top-bar__view-toggle-button--active' : ''
          }`}
          aria-pressed={activeView === 'map'}
          onClick={() => onViewChange('map')}
        >
          Map
        </button>
        <button
          type="button"
          className={`citizen-map-mobile-top-bar__view-toggle-button${
            activeView === 'list' ? ' citizen-map-mobile-top-bar__view-toggle-button--active' : ''
          }`}
          aria-pressed={activeView === 'list'}
          onClick={() => onViewChange('list')}
        >
          List
        </button>
      </div>
      <button type="button" className="citizen-map-mobile-top-bar__filter-button" onClick={onFilterClick}>
        <span className="citizen-map-mobile-top-bar__filter-button-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 5H21L14 13V19L10 17V13L3 5Z"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span>Filter</span>
      </button>
    </div>
  );
}
